<template>
    <div class="container">
        <span class="label ellipsis">{{label}}</span><span class="percent">{{percent}}%</span>
        <span class="progress" :class="theme" :style="{width: `${percent}%`}"></span>
    </div>
</template>

<script>
    export default {
        name: "FileUploadProgress",
        props: {
            percent: {
                type: Number,
                default: 0
            },
            theme: {
                type: String,
                default: 'theme-1',
                validator: val => /(theme-1|red|blue)/.test(val)
            },
            label: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";
    .container {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: 1.2em 1em;
        grid-template-areas: 'label percent' 'progress progress';

        .label {
            grid-area: label;
            font-size: .8em;
        }

        .percent {
            font-size: .8em;
            grid-area: percent;
            text-align: right;
        }

        .progress {
            grid-area: progress;
            width: 40%;
            height: 4px;
            transition: width .5s ease-out, color .2s ease;
            border-radius: 2px;

            &.theme-1 {
                background-color: $theme_color_one;
            }
            &.red {
                background-color: #f00;
            }

            &.blue {
                background-color: #0069d9;
            }
        }
    }
</style>
